<template>
  <div class="TableSimple">
    <el-table :size="size" :ref="refe" stripe :data="listData.data" style="width: 100%; overflow-x: auto;" class="table-scroll" @cell-click="cellClick" @cell-dblclick="dblclick" @row-contextmenu="rowContextmenu">
      <el-table-column v-if="multipleSelect" type="selection" width="55" />
      <slot />
      <div slot="empty">
        <el-empty :description="emptyMessage"></el-empty>
      </div>
    </el-table>
    <el-pagination
      v-if="listData.current_page"
      @current-change="changeToPage"
      background
      layout="prev, pager, next"
      :page-size="Number(listData.per_page)"
      :current-page="listData.current_page"
      :total="listData.total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: "TableSimple",
  props: {
    listData: Object,
    cellClick: {
      type: Function,
      default: function () {}
    },
    dblclick: {
      type: Function,
      default: function () {}
    },
    rowContextmenu: {
      type: Function,
      default: function () {}
    },
    multipleSelect: {
      type: Boolean,
      default: false
    },
    refe: {
      type: String,
      default: 'tableSimple'
    },
    size: {
      type: String,
      default: "-"
    },
    emptyMessage: {
      type: String,
      default: "Nenhum dado encontrado."
    }
  },
  methods: {
    changeToPage (page) {
      this.$emit('paginationClick', {page: page, meta: this.listData})
    },
  }
}
</script>

<style lang="scss" scoped>
.TableSimple {
  text-align: center;
  overflow: auto !important;
  .el-pagination {
    margin-top: 25px;
  }
}
</style>
